import {
  productFamilyIdFormat,
  productIdFormat,
} from "@redotech/redo-ids-cockroach";
import { ListingType as DbListingType } from "@redotech/redo-prisma-client/enums";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export enum ListingType {
  General = "general",
  Shopify = "shopify",
  ChatGpt = "chatgpt",
  Amazon = "amazon",
  Walmart = "walmart",
  Perplexity = "perplexity",
  RedoMarketplace = "redo-marketplace",
  Ebay = "ebay",
  GoogleShopping = "google-shopping",
}
export const ListingTypeSchema = createEnum(ListingType);

export const BaseProductFamilyListingSchema = z.object({
  listingType: ListingTypeSchema,
  productFamilyId: productFamilyIdFormat.schema,
});

export const BaseProductListingSchema = z.object({
  listingType: ListingTypeSchema,
  productId: productIdFormat.schema,
});

const ListingTypeToDbListingType: Record<ListingType, DbListingType> = {
  [ListingType.General]: DbListingType.general,
  [ListingType.Shopify]: DbListingType.shopify,
  [ListingType.ChatGpt]: DbListingType.chatgpt,
  [ListingType.Amazon]: DbListingType.amazon,
  [ListingType.Walmart]: DbListingType.walmart,
  [ListingType.Perplexity]: DbListingType.perplexity,
  [ListingType.RedoMarketplace]: DbListingType.redo_marketplace,
  [ListingType.Ebay]: DbListingType.ebay,
  [ListingType.GoogleShopping]: DbListingType.google_shopping,
};

const DbListingTypeToListingType: Record<DbListingType, ListingType> =
  Object.fromEntries(
    Object.entries(ListingTypeToDbListingType).map(
      ([listingType, dbListingType]) => [
        dbListingType,
        listingType as ListingType,
      ],
    ),
  ) as Record<DbListingType, ListingType>;

export function getDbListingType(listingType: ListingType): DbListingType {
  return ListingTypeToDbListingType[listingType];
}

export function getListingType(dbListingType: DbListingType): ListingType {
  return DbListingTypeToListingType[dbListingType];
}
